import orders from '@/store/modules/sales/orders'
import quotes from '@/store/modules/sales/quotes'

const modules = {
  orders,
  quotes
}

export default {
  namespaced: true,
  modules
}
